import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  const faqs = [
    {
      question: "What if I have a low credit score?",
      answer: "Your credit score doesn't affect your eligibility. We specialize in helping clients regardless of their credit history."
    },
    {
      question: "Are there any upfront costs?",
      answer: "No. Our services are structured to be affordable, with fees included in the savings we secure for you."
    },
    {
      question: "How long does the process take?",
      answer: "Most clients see results within weeks. Our efficient process is designed to provide relief as quickly as possible."
    },
    {
      question: "Will this affect my assets?",
      answer: "No. Our solution is designed to protect your assets while helping you reduce your debt."
    }
  ];

  return (
    <div className="py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl font-bold text-center text-white mb-12">
          Frequently Asked Questions
        </h2>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border border-white/10 rounded-lg px-4 bg-white/5 backdrop-blur-sm"
            >
              <AccordionTrigger className="text-white hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-300">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};